import {
  adaptedToImmeuble,
  immeubleToAdapted,
  immeublesToAdapted,
} from "../../adapter/immeubleAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_IMMEUBLES = "LOAD_SUCCESS_IMMEUBLES";
export const LOAD_FAIL_IMMEUBLES = "LOAD_FAIL_IMMEUBLES";
export const SAVE_SUCCESS_IMMEUBLES = "SAVE_SUCCESS_IMMEUBLES";
export const SAVE_FAIL_IMMEUBLES = "SAVE_FAIL_IMMEUBLES";
export const UPDATE_SUCCESS_IMMEUBLES = "UPDATE_SUCCESS_IMMEUBLES";
export const UPDATE_FAIL_IMMEUBLES = "UPDATE_FAIL_IMMEUBLES";
export const DELETE_SUCCESS_IMMEUBLES = "DELETE_SUCCESS_IMMEUBLES";
export const DELETE_FAIL_IMMEUBLES = "DELETE_FAIL_IMMEUBLES";

export function loadImmeubles() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch("immeubles", HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.immeuble);
          dispatch({
            type: LOAD_SUCCESS_IMMEUBLES,
            payload: immeublesToAdapted(res.immeuble),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_IMMEUBLES,
            error: err,
          });
        });
    });
  };
}

export function saveImmeuble(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch("immeubles", HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToImmeuble(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.immeuble);
          dispatch({
            type: SAVE_SUCCESS_IMMEUBLES,
            payload: immeubleToAdapted(res.immeuble),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_IMMEUBLES,
            error: err,
          })
        );
    });
  };
}

export function updateImmeuble(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`immeubles/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToImmeuble(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.immeuble);
          dispatch({
            type: UPDATE_SUCCESS_IMMEUBLES,
            payload: immeubleToAdapted(res.immeuble),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_IMMEUBLES,
            error: err,
          })
        );
    });
  };
}

export function deleteImmeuble(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`immeubles/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.immeuble);
          dispatch({
            type: DELETE_SUCCESS_IMMEUBLES,
            payload: immeubleToAdapted(res.immeuble),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_IMMEUBLES,
            error: err,
          });
        });
    });
  };
}
